'use strict';
import {convertDataVToVue} from '../apply_vue_data_directives.js';
import {Gallery} from './gallery.js';

export class GalleryProfile extends Gallery {
	Vue;
	constructor(component_id) {
		super(component_id);
	}

}